import {
  Box,
  DialogContent,
  DialogTitle,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import { customerBusiness } from "api/bussiness/customer/customer-bussiness";
import { AddCustomer as AddCustomerModel } from "api/models/request/customer/customer";
import { DynamicForm } from "commons/ultilities/dynamic-form/components/dynamic-form";
import { DynamicFormArray } from "commons/ultilities/dynamic-form/components/dynamic-form-array";
import { useForm } from "commons/ultilities/dynamic-form/hooks/use-form";
import { IControl } from "commons/ultilities/dynamic-form/models/control";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useEffect, useMemo } from "react";
import { AddButton } from "share-components/mui-wrap/button/action-button";
import { DialogForm } from "share-components/templates/form/dialog-form";
import { customerFormSchema } from "../schema";

export const AddCustomer = observer(() => {
  const {
    customerManagement: {
      openNew,
      getCustomers,
      setProp,
      pagination,
      showIsDisabled,
    },
    catalogueStore: {
      getCustomerTypes,
      cataloguesToOptionItems,
      defaultOptionItem,
      customerTypes,
    },
  } = useStores();
  const {
    form: { controls, isValid },
    getControl,
    getControlArray,
    submitHandler,
  } = useForm<AddCustomerModel>(customerFormSchema(), {
    code: "",
    name: "",
    dealingName: "",
    customerTypeId: "",
    headOfficeAddress: "",
    note: "",
    taxCode: "",
    isDisabled: false,
    deliveryAddresses: [
      {
        address: "",
      },
    ],
  });

  const deliveryAddressesFormArray = useMemo(() => {
    return getControlArray("deliveryAddresses");
  }, [getControlArray]);

  const saveHandler = useCallback(
    async (data: AddCustomerModel) => {
      try {
        await customerBusiness.add(data);
        await getCustomers({
          filter: pagination.filter,
          maxResultCount: pagination.itemsPerPage,
          skipCount: pagination.skipCount,
          isDisabled: showIsDisabled,
        });
        setProp("openNew", false);
      } catch (ex) {
        console.error(ex);
      }
    },
    [
      getCustomers,
      pagination.filter,
      pagination.itemsPerPage,
      pagination.skipCount,
      setProp,
      showIsDisabled,
    ]
  );

  useEffect(() => {
    getCustomerTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (customerTypes) {
      const options = cataloguesToOptionItems(customerTypes);
      const defaultCustomerTypeSelected = defaultOptionItem(customerTypes);
      const control = getControl("customerTypeId");
      control.setProp("optionItems", options);
      if (defaultCustomerTypeSelected.value) {
        control.setDefaultValue(defaultCustomerTypeSelected?.value);
      }
    }
  }, [cataloguesToOptionItems, customerTypes, defaultOptionItem, getControl]);

  return (
    <DialogForm
      open={openNew}
      fullWidth
      maxWidth={"md"}
      onClose={() => setProp("openNew", false)}
      onCancelBtnClicked={() => setProp("openNew", false)}
      onSaveBtnClick={async () => await submitHandler(saveHandler)}
      saveBtnProps={{
        disabled: !isValid,
      }}
    >
      <DialogTitle>Thêm mới khách hàng</DialogTitle>
      <DialogContent>
        <Box sx={{ marginTop: "10px" }}>
          <DynamicForm controls={controls}></DynamicForm>
          <DeliveryAddressesFormArray
            deliveryAddressesControl={getControl("deliveryAddresses")}
            deliveryAddressesFormArray={deliveryAddressesFormArray}
          ></DeliveryAddressesFormArray>
        </Box>
      </DialogContent>
    </DialogForm>
  );
});
type DeliveryAddressesProps = {
  deliveryAddressesControl: IControl;
  deliveryAddressesFormArray: IControl[][];
};
const DeliveryAddressesFormArray = observer(
  ({
    deliveryAddressesFormArray,
    deliveryAddressesControl,
  }: DeliveryAddressesProps) => {
    const onAddMoreDeliveryAddress = useCallback(() => {
      deliveryAddressesControl.addNewChild();
    }, [deliveryAddressesControl]);

    const removeRowHandler = useCallback(
      (rowIdx: number) => {
        deliveryAddressesControl.removeChildByIndex(rowIdx);
      },
      [deliveryAddressesControl]
    );
    return (
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Stack
            direction={"row"}
            spacing={1}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Typography variant="subtitle2">
              {deliveryAddressesControl.label}
            </Typography>
            <AddButton onClick={onAddMoreDeliveryAddress}></AddButton>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          {deliveryAddressesFormArray &&
            deliveryAddressesFormArray.length > 0 && (
              <DynamicFormArray
                children={deliveryAddressesFormArray}
                onRemoveRowClick={removeRowHandler}
              ></DynamicFormArray>
            )}
        </Grid>
      </Grid>
    );
  }
);
